export default "__VITE_ASSET__4Ufi2Siw__"